import { Ban, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const EVENT_LABEL = {
  rate_limited: "Rate limit (IP travado)",
  ip_blocked_access: "Acesso de IP na lista negra",
  login_failed: "Login falhado",
  login_blocked: "Conta bloqueada",
};
export const IP_EVENTS = ["rate_limited", "ip_blocked_access"];

export const SecurityTotals = ({ totals }) => (
  <div className="grid grid-cols-3 gap-3 text-center">
    {Object.entries(totals).map(([key, value]) => (
      <div key={key} className="rounded-md border border-[#22252F] bg-[#0F1116] p-3">
        <p data-testid={`security-total-${key}`} className="font-mono text-lg text-white">{value}</p>
        <p className="mt-1 text-xs text-[#94A3B8]">{EVENT_LABEL[key] || key}</p>
      </div>
    ))}
  </div>
);

export const SecurityEventRow = ({ event, blocked, onBlock }) => {
  const isIp = IP_EVENTS.includes(event.event);
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border-b border-[#1B1E26] py-2 font-mono text-xs">
      <span className={isIp ? "text-[#F59E0B]" : "text-[#94A3B8]"}>
        {EVENT_LABEL[event.event] || event.event}
      </span>
      <span className="text-white">{event.identifier}</span>
      <span className="flex items-center gap-3">
        <span className="text-[#64748B]">{new Date(event.created_at).toLocaleString("pt-PT")}</span>
        {isIp && !blocked ? (
          <Button data-testid={`block-ip-${event.identifier}`} size="sm" onClick={onBlock}
                  className="h-7 rounded-md bg-[#EF4444] px-3 text-xs hover:bg-[#DC2626]">
            <Ban className="mr-1.5 h-3 w-3" /> Bloquear
          </Button>
        ) : null}
      </span>
    </div>
  );
};

export const BlockedIpRow = ({ entry, onUnblock }) => (
  <div className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-[#EF4444]/30 bg-[#EF4444]/5 px-3 py-2 font-mono text-xs">
    <span className="text-white">
      {entry.ip}
      {entry.ip.includes("/") ? <span className="ml-2 text-[#F59E0B]">intervalo</span> : null}
    </span>
    <span className="text-[#64748B]">{entry.note || "sem nota"}</span>
    <Button data-testid={`unblock-ip-${entry.ip}`} size="sm" onClick={onUnblock}
            className="h-7 rounded-md bg-[#22252F] px-3 text-xs hover:bg-[#2E323D]">
      <Trash2 className="mr-1.5 h-3 w-3" /> Desbloquear
    </Button>
  </div>
);
